import React from 'react';
import { Field } from '..';
import { ChildrenProps } from '../../../../types';

type Props = {
  when: string;
  is: string;
  children: ChildrenProps;
};

const Condition = ({ when, is, children }: Props) =>
  is.split('|').map((condition) => (
    <Field key={condition} name={when} subscription={{ value: true }}>
      {({ input: { value } }) => (value === condition ? children : null)}
    </Field>
  ));

export default Condition;
